export class ConfigDB {
  static data = {
    settings: {
      layout_type: 'ltr',
      sidebar: {
        type: 'compact-wrapper',
        iconType: 'stroke-svg',
      },
      sidebar_setting: 'default-sidebar',
    },
    color: {
      primary_color: localStorage.getItem('default_color') || '#1b255b',
      secondary_color: localStorage.getItem('secondary_color') || '#a07d2c',
      mix_background_layout: 'dark-sidebar',
    },
    router_animation: 'fadeIn',
  };
}
export default ConfigDB;
